import React from 'react';
import Article from '../../styled-components/Article';
import Hand from '../../styled-components/Hand';
import H2 from '../../styled-components/H2';
import P from '../../styled-components/P';
import Blockquote from '../../styled-components/Blockquote';
import Testimonials from '../../styled-components/Testimonials';
import Quote from '../../styled-components/Quote';
import Cite from '../../styled-components/Cite';
import pointer from '../../img/pointer.svg';
import avatar from '../../img/avatar.jpg';
import testimonialBg from '../../img/bg-testimonial.jpg';

class Creators extends React.Component {
  render() {
    const testimonials = this.props.testimonials.map((testimonial, i) => {
      return (
        <Blockquote key={i} centeredText>
          <Cite bg={testimonial.avatar}>
            {testimonial.author}
          </Cite>
          <Quote>
            <span dangerouslySetInnerHTML={{ __html: testimonial.quote}} />
          </Quote>
        </Blockquote>
      );
    })
    return (
      <Article bgColor={'#E7F8FC'}>
        <Hand src={pointer} top="20%" right="0"  hideOnMobile/>
        <H2>{this.props.title}</H2>
        <Testimonials>
          {testimonials}
        </Testimonials>
      </Article>
    )
  }
}

export default Creators;



// WEBPACK FOOTER //
// ./src/components/Creators/index.js